import React, { useEffect, useCallback, useState} from 'react';
import {getPath} from "components/effects/rack/getPath.js"
import Arrow from "components/effects/rack/Arrow.js";
import {
    setSelectedPadEdge,
    setDrawingPadEdge,
       } from 'actions/index.js';
import {useEffectKeys} from './useEffectKeys.js';
import Edge from "components/pulled/Edge.js";
import EffectEdges from "components/pulled/EffectEdges.js";
import {connect} from 'react-redux';

const AllEdges = ({
    setSelectedPadEdge,
    setDrawingPadEdge,
    isCollapsed,
    pad,
    effects=[],
    fromId,
    controlEdges,
    isMidi,
    drawingEdge,
    selectedElements,
    outputPrefix="output-node-",
    edgesRef,
    ...props
}) => { 
    if (!pad || !pad.effectRack || !pad.effectRack.adjacencyLists) {
        return [];
    }

    if (isCollapsed) {
        return (
            <Edge
              scale={props.scale}
              sequencerEngine={pad.sequencerEngine}
              fromId={pad.id}
              edgesRef={edgesRef}
              test={true}
              outputPrefix={"output-node-"}
              padZObject={pad.zObject}
              pad={pad}
              edge={{effect: {id: -1}}}
              {...props}/>);
    }

    return (
        <g className="all-edges">
          <EffectEdges
            id={-1}
            pad={pad}
            fromId={pad.effectRack.id}
            outputPrefix={isMidi && outputPrefix }
            ffrom={-1}
            edgesRef={edgesRef}
            fromWindow={fromId}
            sequencerEngine={pad.sequencerEngine}
            fx={pad.effectRack}
            {...props}/>
          
          {!isMidi && <Edge
                        scale={props.scale}
                        fromId={pad.id}
                        sequencerEngine={pad.sequencerEngine}
                        fromWindow={fromId}
                        edgesRef={edgesRef}
                        test={true}
                        padZObject={pad.zObject}
                        outputPrefix={outputPrefix }
                        pad={pad}
                        edge={{effect: {id: -1}}}
                        {...props}/>}
          {effects.map(
              fx =>
                  <EffectEdges
                    key={fx.id}
                        edgesRef={edgesRef}
                    pad={pad}
                    fx={fx}
                    {...props}/>
          )}
        </g>
    );
};

const mapStateToProps = (state, props) => {
    if (!props.pad) {
        return {};
    }
    let adj = props.pad.effectRack && props.pad.effectRack.adjacencyLists &&
        props.pad.effectRack.adjacencyLists[-1];
    return {
        controlEdges: adj && adj.length,
        isCollapsed: props.pad.effectRack && state.effects.effectCollapsed[
            props.pad.effectRack.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEdges);
